module.exports = __webpack_public_path__ + "static/hero-02-fa729ad4a6b7cb29f4d461028458bbb9.jpg";